export enum UomCategoryEnum {
    LENGTH = 'Length',
    MASS = 'Weight',
    AREA = 'Area',
    VOLUME = 'Volume'
}